// components/SmartWordsSection.jsx
import React from "react";
import { Link } from "react-router-dom";
import SectionHeading from "./SectionHeading";
import Reveal from "./Reveal";
import styles from "../Info.module.css";

const SmartWordsSection = () => {
  return (
    <section className={styles.section} id="phrases">
      <div className={styles.sectionInner}>
        <Reveal>
          <SectionHeading
            badge="ویژه ⭐"
            badgeColor="gold"
            title="موتور هوشمند لغات و اصطلاحات"
            subtitle="ما فقط لغت استخراج نمی‌کنیم — ارزش آموزشی هر عبارت رو می‌سنجیم."
          />
        </Reveal>

        <Reveal delay={100}>
          <div className={styles.smartGrid}>
            <div className={styles.videoBox}>
              <div className={styles.videoPlaceholder}>
                <div className={styles.videoGlow}></div>
                <div className={styles.videoPlayWrap}>
                  {/* TODO: add video — ویدیو کوتاه (۱۰-۲۰ ثانیه) اینجا قرار می‌گیره */}
                  <span className={styles.videoPlayBtn}>
                    <i className="fas fa-play"></i>
                  </span>
                  <span>ویدیو به‌زودی — نمایش کوتاه ویژگی</span>
                </div>
              </div>
            </div>

            <div className={styles.compareCards}>
              <div className={`${styles.compareCard} ${styles.goldCard}`}>
                <span className={styles.cardLabel}>
                  <i className="fas fa-crown"></i>
                  عبارت کلیدی
                </span>
                <span className={styles.cardWord}>have more in common with</span>
                <span className={styles.cardMeaning}>
                  وجه مشترک داشتن با کسی
                </span>
                <span className={styles.cardExample}>
                  «I never thought we'd have so much in common.»
                </span>
                <div className={styles.cardMetaRow}>
                  <span className={styles.cardMeta}>
                    مترادف: share, have something with
                  </span>
                  <span className={styles.cardMeta}>
                    متضاد: have nothing with
                  </span>
                  <span className={styles.cardMeta}>CEFR: B1</span>
                </div>
              </div>

              <div className={`${styles.compareCard} ${styles.grayCard}`}>
                <span className={styles.cardLabel}>
                  <i className="fas fa-circle-info"></i>
                  عبارت حاشیه‌ای
                </span>
                <span className={styles.cardWord}>the clown</span>
                <span className={styles.cardMeaning}>دلقک — فقط اشاره‌ای کوتاه</span>
              </div>
            </div>
          </div>
        </Reveal>

        <Reveal delay={150}>
          <p className={styles.emphasisText}>
            ما فقط لغت استخراج نمی‌کنیم —{" "}
            <strong>ارزش آموزشی هر عبارت رو می‌سنجیم.</strong>
          </p>
          <div className={styles.inlineCta}>
            <Link to="/Subscription" className={styles.ctaInlineBtn}>
              همین حالا با موتور هوشمند شروع کن
              <i className="fas fa-arrow-left"></i>
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default SmartWordsSection;